import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register the PWA service worker. Required for the "Install LAST" button
// to appear (Chrome/Edge gate `beforeinstallprompt` on having a registered SW).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
  // When a freshly-installed SW activates, it broadcasts `sw-updated`. We
  // used to force an immediate `window.location.reload()` here — but that
  // meant every deploy caused a jarring black-screen flash mid-session for
  // anyone with the tab already open. Instead: remember that an update is
  // ready and only reload once the tab is actually hidden/backgrounded —
  // completely invisible to the user, since they're not looking at it —
  // rather than yanking the page out from under whatever they're doing.
  // If the tab is never backgrounded, the next real navigation (closing +
  // reopening the tab, hitting refresh) picks up the new bundle anyway,
  // since the SW's fetch handler always sends HTML navigations straight
  // to the network (see sw.js) rather than serving a cached shell.
  let updateReady = false;
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data && event.data.type === "sw-updated") {
      updateReady = true;
    }
  });
  document.addEventListener("visibilitychange", () => {
    if (updateReady && document.visibilityState === "hidden") {
      updateReady = false;
      window.location.reload();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
